import axios from "const/axios";

const base = "/referral-applications";

const dataOf = (res) => res?.data?.data ?? null;

export const fetchApplicationRequestQueue = async (params = {}) => {
  const res = await axios.get(base, { params });
  return res?.data?.data ?? { content: [] };
};

export const fetchClientApplicationRequests = async (clientId) => {
  const res = await axios.get(`${base}/client/${clientId}`);
  return dataOf(res) ?? [];
};

export const fetchApplicationRequest = async (requestId) => {
  const res = await axios.get(`${base}/${requestId}`);
  return dataOf(res);
};

export const approveApplicationRequest = async (requestId, adminNote) => {
  const res = await axios.post(`${base}/${requestId}/approve`, { adminNote: adminNote || null });
  return dataOf(res);
};

export const rejectApplicationRequest = async (requestId, reason) => {
  const res = await axios.post(`${base}/${requestId}/reject`, { adminNote: reason });
  return dataOf(res);
};

export const setApplicationVisibility = async (moduleType, moduleId, visible) => {
  const res = await axios.patch(`${base}/visibility`, {
    moduleType,
    moduleId,
    visible,
  });
  return dataOf(res);
};

export const fetchApplicationProvenance = async (moduleType, moduleId) => {
  const res = await axios.get(`${base}/provenance`, {
    params: { module: moduleType, moduleId },
  });
  return dataOf(res);
};

export const fetchClientReferralState = async (clientId) => {
  if (!clientId) return null;
  const res = await axios.get(`/clients/${clientId}`);
  const client = res?.data?.data ?? res?.data ?? null;
  if (!client) return null;
  return {
    id: client.id ?? clientId,
    name: client.name || client.fullName || "",
    referralPartnerId: client.referralPartnerId ?? null,
    referral: client.referral || "",
    customReferral: client.customReferral || false,
  };
};
